const SH = 'text-2xl font-extrabold text-slate-900 mt-12 pt-8 border-t border-slate-200';

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12 prose prose-slate">
      <h1>Privacy Policy</h1>
      <p>
        This Policy applies as between you, the User of this Web Site and Learnable the owner and
        provider of this Web Site. This Policy applies to our use of any and all Data collected by
        us in relation to your use of the Web Site and any Services or Systems therein.
      </p>

      <h2 className={SH}>1. Definitions and Interpretation</h2>
      <p>In this Policy the following terms shall have the following meanings:</p>
      <ul>
        <li>
          <strong>&ldquo;Account&rdquo;</strong>: means collectively the personal information, Payment
          Information and credentials used by Users to access Material and/or any communications
          System on the Web Site;
        </li>
        <li>
          <strong>&ldquo;Content&rdquo;</strong>: means any text, graphics, images, audio, video,
          software, data compilations and any other form of information capable of being stored in a
          computer that appears on or forms part of this Web Site;
        </li>
        <li>
          <strong>&ldquo;Cookie&rdquo;</strong>: means a small text file placed on your computer by
          Learnable when you visit certain parts of this Web Site. This allows us to identify
          recurring visitors and to analyse their browsing habits within the Web Site;
        </li>
        <li>
          <strong>&ldquo;Data&rdquo;</strong>: means collectively all information that you submit to
          the Web Site. This includes, but is not limited to, Account details and information
          submitted using any of our Services or Systems;
        </li>
        <li>
          <strong>&ldquo;Learnable&rdquo;</strong>: means Learnable, a division of ADE Incorporated;
        </li>
        <li>
          <strong>&ldquo;Service&rdquo;</strong>: means collectively any online facilities, tools,
          services or information that Learnable makes available through the Web Site either now or
          in the future;
        </li>
        <li>
          <strong>&ldquo;System&rdquo;</strong>: means any online communications infrastructure that
          Learnable makes available through the Web Site either now or in the future. This includes,
          but is not limited to, web-based email, message boards, live chat facilities and email links;
        </li>
        <li>
          <strong>&ldquo;User&rdquo; / &ldquo;Users&rdquo;</strong>: means any third party that
          accesses the Web Site and is not employed by Learnable and acting in the course of their
          employment; and
        </li>
        <li>
          <strong>&ldquo;Web Site&rdquo;</strong>: means the website that you are currently using
          (learnableskill.com) and any sub-domains of this site unless expressly excluded by their
          own terms and conditions.
        </li>
      </ul>

      <h2 className={SH}>2. Data Collected</h2>
      <p>Without limitation, any of the following Data may be collected:</p>
      <ol>
        <li>Name</li>
        <li>Date of birth</li>
        <li>Job title &amp; profession</li>
        <li>Contact information such as email addresses and telephone numbers</li>
        <li>Demographic information such as post code, preferences and interests</li>
        <li>Financial information such as credit/debit card numbers</li>
        <li>IP address (automatically collected)</li>
        <li>Web browser type and version (automatically collected)</li>
        <li>Operating system (automatically collected)</li>
        <li>
          A list of URLs starting with a referring site, your activity on this Web Site, and the
          site you exit to (automatically collected)
        </li>
        <li>Cookie information (see Section 10 below)</li>
      </ol>

      <h2 className={SH}>3. Our Use of Data</h2>
      <p>
        Any personal Data you submit will be retained by Learnable for as long as you use the
        Services and Systems provided on the Web Site. Data that you may submit through any
        communications System that we may provide may be retained for a longer period of up to
        one year.
      </p>
      <p>
        Unless we are obliged or permitted by law to do so, and subject to Section 4, your Data will
        not be disclosed to third parties. This includes our affiliates and/or other companies within
        our group.
      </p>
      <p>
        All personal Data is stored securely in accordance with applicable data protection principles.
        For more details on security, see Section 9 below.
      </p>
      <p>
        Any or all of the above Data may be required by us from time to time in order to provide you
        with the best possible service and experience when using our Web Site. Specifically, Data may
        be used by us for the following reasons:
      </p>
      <ul>
        <li>Internal record keeping</li>
        <li>Improvement of our products and services</li>
        <li>Transmission by email of promotional materials that may be of interest to you</li>
        <li>
          Contact for market research purposes which may be done using email, telephone, fax or mail.
          Such information may be used to customise or update the Web Site
        </li>
      </ul>

      <h2 className={SH}>4. Third Party Web Sites and Services</h2>
      <p>
        Learnable may, from time to time, employ the services of other parties for dealing with
        matters that may include, but are not limited to, payment handling, delivery of purchased
        items, search engine facilities, advertising and marketing. The providers of such services
        do not have access to certain personal Data provided by Users of this Web Site. Any Data
        used by such parties is used only to the extent required by them to perform the services
        that Learnable requests. Any use for other purposes is strictly prohibited. Furthermore,
        any Data that is processed by third parties must be processed within the terms of this
        Policy and in accordance with applicable data protection laws.
      </p>

      <h2 className={SH}>5. Changes of Business Ownership and Control</h2>
      <p>
        Learnable may, from time to time, expand or reduce its business and this may involve the
        sale of certain divisions or the transfer of control of certain divisions to other parties.
        Data provided by Users will, where it is relevant to any division so transferred, be
        transferred along with that division and the new owner or newly controlling party will,
        under the terms of this Policy, be permitted to use the Data for the purposes for which it
        was supplied by you.
      </p>
      <p>
        In the event that any Data submitted by Users will be transferred in such a manner, you
        will be contacted in advance and informed of the changes. When contacted you will be given
        the choice to have your Data deleted or withheld from the new owner or controller.
      </p>

      <h2 className={SH}>6. Controlling Access to Your Data</h2>
      <p>
        Wherever you are required to submit Data, you will be given options to restrict our use of
        that Data. This may include the following:
      </p>
      <ul>
        <li>Use of Data for direct marketing purposes</li>
        <li>Sharing Data with third parties</li>
      </ul>

      <h2 className={SH}>7. Your Right to Withhold Information</h2>
      <p>
        You may access certain areas of the Web Site without providing any Data at all. However, to
        use all Services and Systems available on the Web Site you may be required to submit Account
        information or other Data.
      </p>
      <p>
        You may restrict your internet browser&rsquo;s use of Cookies. For more information see
        Section 10 below.
      </p>

      <h2 className={SH}>8. Accessing Your Own Data</h2>
      <p>
        You may access your Account at any time to view or amend the Data. You may need to modify
        or update your Data if your circumstances change. Additional Data as to your marketing
        preferences may also be stored and you may change this at any time.
      </p>
      <p>
        You have the right to ask for a copy of your personal Data on payment of a small fee.
      </p>

      <h2 className={SH}>9. Security</h2>
      <p>
        Data security is of great importance to Learnable and to protect your Data we have put in
        place suitable physical, electronic and managerial procedures to safeguard and secure Data
        collected online.
      </p>

      <h2 className={SH}>10. Changes to This Policy</h2>
      <p>
        Learnable reserves the right to change this Privacy Policy as we may deem necessary from
        time to time or as may be required by law. Any changes will be immediately posted on the
        Web Site and you are deemed to have accepted the terms of the Policy on your first use of
        the Web Site following the alterations.
      </p>

      <h2 className={SH}>11. Contacting Us</h2>
      <p>
        If there are any questions regarding this privacy policy you may contact us
        at{' '}
        <a href="mailto:renee@learnableskill.com">renee@learnableskill.com</a>.
      </p>
    </div>
  );
}
